import React from "react";
/**
 * Render the header cell for the week numbers column.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function WeekNumberHeader(props) {
    return React.createElement("th", { ...props });
}
//# sourceMappingURL=WeekNumberHeader.js.map